import { createSelector } from 'reselect';
import {
  allowedRoles,
  roleNames,
} from 'constants/user';

const getUser = state => state.user.get('data');

const getRoleInfo = state => {
  const user = state.user.get('data');
  return {
    isHierarchical: user.get('hierarchical'),
    isInternal: user.get('internal'),
    roles: user.get('role'),
  }
};

export const getInitialUserFormValues = createSelector(
  [getUser],
  user => {
    return {
      firstName: user.get('firstName'),
      lastName: user.get('lastName'),
      emailAddress: user.get('emailAddress'),
    };
  }
);

export const ableToUpdateRecipeVisibility = createSelector(
  [getUser],
  user => {
    if (user === null) {
      return false;
    }
    const roles = user.role;

    if (roles === null || roles === undefined || user.role.findIndex === undefined) {
      return false;
    }

    const validUserRoles = roles.filter(item => allowedRoles.includes(item));

    return !!validUserRoles && validUserRoles.length > 0;
  }
);

/**
 * Get role related info for the system user
 */
export const deriveRoleInfo = createSelector(
  [getRoleInfo],
  roleProps => {
    const roleInfo = {
      isHierarchical: roleProps.isHierarchical,
      isInternal: roleProps.isInternal,
      changeAccAllowed: false,
      name: null,
    }

    if (!Array.isArray(roleProps.roles) || !roleProps.roles.length) {
      return roleInfo;
    }

    const nonUserRoles = roleProps.roles.filter(item => item != roleNames.USER);
    // a user cannot have multiple roles
    if (nonUserRoles.length !== 1) {
      return roleInfo;
    }

    const role = nonUserRoles[0];
    roleInfo.name = role;

    if (roleInfo.isHierarchical || roleInfo.isInternal || role === roleNames.MULTI_BUYER) {
      roleInfo.changeAccAllowed = true;
    }

    return roleInfo;
  }
);
